document.addEventListener("DOMContentLoaded", () => {
  // Click trigger for elements with .clicker class
  document.querySelectorAll(".clicker").forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();

      let clickClass = element.dataset.clicker
        ? element.dataset.clicker
        : element.getAttribute("href");

      if (clickClass !== undefined) {
        if (clickClass.indexOf(",") < 0) {
          let target = document.querySelector(clickClass);
          if (target) {
            target.click();
          }
        } else {
          let classes = clickClass.split(",");
          classes.forEach(function (cls) {
            let target = document.querySelector(cls.trim());
            if (target) {
              target.click();
            }
          });
        }
      }
    });
  });
});
